/*
 *  Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import * as queryString from "query-string";
import { generatePath, Link, useHistory } from "react-router-dom";
import {
  Box,
  FlexContainer,
  Spacer,
  SVGIcon,
  Text,
  theme,
} from "@nordcloud/gnui";
import {
  BrickLoader,
  DataDisplayWrapper,
  KpiWidgets,
  LoaderWrap,
  NoKPI,
} from "~/components";
import { KpiType } from "~/constants";
import { ROUTES } from "~/routing/routes";
import { isNotNil } from "~/tools";
import { useWidgetData } from "./hooks";

export function HomeKPIWidget() {
  const {
    costAllocationCoverage,
    overallWaste,
    nonProdHours,
    businessContext,
    loading,
  } = useWidgetData();
  const history = useHistory();

  const handleClick = (kpiType: KpiType) => {
    const query = queryString.stringify({ kpiType });
    history.push(`${ROUTES.finopsKpi.index}?${query}`);
  };

  const visualName = isNotNil(businessContext.id) ? (
    <Link
      to={generatePath(ROUTES.businessContexts.structure, {
        structureId: businessContext.id ?? "/",
      })}
    >
      <Text
        weight="medium"
        css={{ color: "inherit" }}
        mb={0}
        data-testid="kpi__primary-bc-name"
      >
        {businessContext.name}
      </Text>
    </Link>
  ) : (
    <Text weight="medium" css={{ color: "inherit" }} mb={0}>
      {businessContext.name}
    </Text>
  );

  return (
    <Box>
      <LoaderWrap
        loading={loading}
        Component={BrickLoader}
        viewBox="0 0 10 1"
        backgroundColor={theme.color.background.ui01}
      >
        <DataDisplayWrapper
          messageComponent={<NoKPI />}
          hasData={isNotNil(businessContext.id)}
        >
          <FlexContainer gap={theme.spacing.spacing01}>
            {visualName}
            <SVGIcon name="starFilled" size="sm" />
            <Text isTitle tag="header" weight="medium">
              KPIs
            </Text>
          </FlexContainer>
          <Spacer height={theme.spacing.spacing03} />
          <KpiWidgets
            costAllocationCoverage={costAllocationCoverage}
            nonProdHours={nonProdHours}
            overallWaste={overallWaste}
            onClick={handleClick}
          />
        </DataDisplayWrapper>
      </LoaderWrap>
    </Box>
  );
}
